import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar10 from "../../assets/images/users/avatar-10.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar7 from "../../assets/images/users/avatar-7.jpg";
import image4 from "../../assets/images/small/img-4.jpg";
import image5 from "../../assets/images/small/img-5.jpg";


export const CommentData = [
   {
    id: 1,
    name: "Joseph Parker",
    time: "20 Dec 2021 - 05:47AM",
    avatar: avatar8,
    badge: "Forward",
    message: "I am getting message from customers that when they place order always get error message.",
    replies: [
      {
        id: 11,
        name: "Alexis Clarke",
        time: "22 Dec 2021 - 02:32PM",
        avatar: avatar10,
        message: "Please be sure to check your Spam mailbox to see if your email filters have identified the email from Dell as spam."
      }
    ]
  },
  {
    id: 2,
    name: "Donald Palmer",
    time: "24 Dec 2021 - 05:20PM",
    badge: "Forward",
    avatar: avatar6,
    message: "If you have further questions, please contact Customer Support from the “Action Menu” on your Online Order Support.",
    replies: []
  },
  
]